import { useNavigate } from 'react-router-dom';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import postHostStream from 'Api/host-stream/postHostStream';
import postEndStreamRequest from 'Domain/host-stream/model/request/postEndStreamRequest';
import postEndStreamResponse from 'Domain/host-stream/model/response/postEndStreamResponse';

import { useToast } from 'Store/toast';
import { useUserInfo } from 'Store/userInfo';
import { useStatusState } from 'Store/status-state';
import { useHostStreamState } from 'View/host-stream/state';
import { useTranslation } from 'react-i18next';

const usePostEndStream = () => {
  const { t } = useTranslation('host-stream');
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const { onOpenStatusState } = useStatusState();
  const { updateState } = useHostStreamState();
  const { userId } = useUserInfo();
  const { onOpenToast } = useToast();

  return useMutation({
    mutationFn: async (data) => {
      const payload = await postEndStreamRequest(data);

      const response = await postHostStream(payload);

      const result = postEndStreamResponse(response);

      return result;
    },
    onSuccess: async () => {
      onOpenStatusState({
        type: 'success',
        title: t('finish_livestream.title'),
        description: t('finish_livestream.description'),
      });

      navigate('/host');
    },
    onError: async (error) => {
      onOpenToast({
        description: error?.response?.data?.errors[0]?.message || t('error.end_livestream'),
        status: 'failed',
        duration: 5,
        position: 'top',
        type: 'mobile',
      });
    },
    onSettled: async () => {
      queryClient.invalidateQueries({ queryKey: ['presences', userId] });
      updateState({ isLoading: false });
    },
  });
};

export default usePostEndStream;
